import { useEffect } from "react";

const REVEAL_SELECTOR = ".content-section, .closing-section";

export function useVisualEffects() {
  useEffect(() => {
    const root = document.documentElement;
    const sections = Array.from(document.querySelectorAll<HTMLElement>(REVEAL_SELECTOR));
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let frame = 0;

    root.classList.add("fx-ready");

    const revealEverything = () => {
      sections.forEach((section) => section.classList.add("is-revealed"));
    };

    const handlePointerMove = (event: PointerEvent) => {
      if (reducedMotion.matches) {
        return;
      }

      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        root.style.setProperty("--pointer-x", `${event.clientX}px`);
        root.style.setProperty("--pointer-y", `${event.clientY}px`);
      });
    };

    if (reducedMotion.matches || !("IntersectionObserver" in window)) {
      revealEverything();
    }

    const observer =
      reducedMotion.matches || !("IntersectionObserver" in window)
        ? null
        : new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.classList.add("is-revealed");
                  observer?.unobserve(entry.target);
                }
              });
            },
            { rootMargin: "0px 0px -10% 0px", threshold: 0.08 },
          );

    observer && sections.forEach((section) => observer.observe(section));
    window.addEventListener("pointermove", handlePointerMove, { passive: true });

    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener("pointermove", handlePointerMove);
      observer?.disconnect();
      root.classList.remove("fx-ready");
      root.style.removeProperty("--pointer-x");
      root.style.removeProperty("--pointer-y");
    };
  }, []);
}
